import React, { useEffect, useState } from 'react';
import { History, Loader2, RefreshCw, CheckCircle2, XCircle } from 'lucide-react';
import { Button } from '../ui/button';
import { adminListLoginActivity } from '../../api';

export const LoginActivityCard = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [onlyFailed, setOnlyFailed] = useState(false);

  const load = () => {
    setLoading(true);
    adminListLoginActivity().then(setRows).catch(() => setRows([])).finally(() => setLoading(false));
  };
  useEffect(load, []);

  const shown = onlyFailed ? rows.filter(r => !r.success) : rows;

  return (
    <div data-testid="login-activity-card" className="rounded-xl border border-cyan-400/10 bg-slate-900/30 p-7">
      <div className="flex items-center justify-between gap-3 mb-2">
        <div className="flex items-center gap-3">
          <History className="w-5 h-5 text-cyan-400" />
          <h3 className="text-xl font-semibold text-white">Sign-in Activity</h3>
        </div>
        <div className="flex items-center gap-2">
          <Button data-testid="login-activity-failed-filter" onClick={() => setOnlyFailed(v => !v)} variant="outline" className={`h-8 border-slate-700 bg-transparent hover:bg-slate-800 ${onlyFailed ? 'text-red-300 border-red-900/60' : 'text-slate-200'}`}>
            {onlyFailed ? 'Showing failed only' : 'Show failed only'}
          </Button>
          <Button data-testid="login-activity-refresh" onClick={load} variant="outline" className="h-8 border-slate-700 bg-transparent hover:bg-slate-800 text-slate-200"><RefreshCw className="w-3.5 h-3.5" /></Button>
        </div>
      </div>
      <p className="text-sm text-slate-400 mb-5">Every admin sign-in attempt, successful or failed. Records are kept for 3 years. Locations are approximate, based on IP address.</p>
      {loading ? (
        <div className="text-slate-400 text-sm"><Loader2 className="w-4 h-4 inline animate-spin mr-2" />Loading...</div>
      ) : shown.length === 0 ? (
        <p data-testid="login-activity-empty" className="text-sm text-slate-500">No sign-in attempts recorded yet.</p>
      ) : (
        <div className="overflow-x-auto max-h-[480px] overflow-y-auto rounded-md border border-cyan-400/10">
          <table data-testid="login-activity-table" className="w-full text-sm">
            <thead className="bg-[#080d18] text-slate-400 text-xs uppercase tracking-wider sticky top-0">
              <tr><th className="text-left px-4 py-2">Time</th><th className="text-left px-4 py-2">User</th><th className="text-left px-4 py-2">Result</th><th className="text-left px-4 py-2">Location</th><th className="text-left px-4 py-2">IP</th></tr>
            </thead>
            <tbody>
              {shown.map(r => (
                <tr key={r.id} data-testid={`login-activity-row-${r.id}`} className="border-t border-slate-800 text-slate-200" title={r.user_agent}>
                  <td className="px-4 py-2 whitespace-nowrap">{new Date(r.created_at.endsWith('Z') || r.created_at.includes('+') ? r.created_at : r.created_at + 'Z').toLocaleString()}</td>
                  <td className="px-4 py-2 font-mono">{r.username}</td>
                  <td className="px-4 py-2">{r.success
                    ? <span className="inline-flex items-center gap-1 text-emerald-400"><CheckCircle2 className="w-3.5 h-3.5" />Success</span>
                    : <span className="inline-flex items-center gap-1 text-red-400"><XCircle className="w-3.5 h-3.5" />Failed</span>}</td>
                  <td className="px-4 py-2">{r.location}</td>
                  <td className="px-4 py-2 font-mono text-slate-400">{r.ip}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default LoginActivityCard;
